var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "submit-document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95801 2.2915V17.7082H11.6663C12.0115 17.7082 12.2913 17.988 12.2913 18.3332C12.2913 18.6783 12.0115 18.9582 11.6663 18.9582H3.83301C3.21169 18.9582 2.70801 18.4545 2.70801 17.8332V2.1665C2.70801 1.54518 3.21169 1.0415 3.83301 1.0415H13.5426C13.8409 1.0415 14.1271 1.16003 14.3381 1.37101L16.9618 3.99478C17.1728 4.20576 17.2913 4.49191 17.2913 4.79028V10.8332C17.2913 11.1783 17.0115 11.4582 16.6663 11.4582C16.3212 11.4582 16.0413 11.1783 16.0413 10.8332V4.84205L13.4908 2.2915H3.95801Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.333 1.0415C13.6782 1.0415 13.958 1.32133 13.958 1.6665V4.37484H16.6663C17.0115 4.37484 17.2913 4.65466 17.2913 4.99984C17.2913 5.34502 17.0115 5.62484 16.6663 5.62484H13.833C13.2117 5.62484 12.708 5.12116 12.708 4.49984V1.6665C12.708 1.32133 12.9878 1.0415 13.333 1.0415Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3911 18.7751C15.6351 19.0192 16.0309 19.0192 16.275 18.7751L18.775 16.2751C19.019 16.031 19.019 15.6353 18.775 15.3912L16.275 12.8912C16.0309 12.6472 15.6351 12.6472 15.3911 12.8912C15.147 13.1353 15.147 13.531 15.3911 13.7751L16.8241 15.2082H13.333C12.9878 15.2082 12.708 15.488 12.708 15.8332C12.708 16.1783 12.9878 16.4582 13.333 16.4582H16.8241L15.3911 17.8912C15.147 18.1353 15.147 18.531 15.3911 18.7751Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.b70d4f3ea07225f96e3a456858ddc7e1.svg";
export { ForwardRef as ReactComponent };